module.exports = __webpack_public_path__ + "assets/f8988c94ebf10c9d3d5bbc18e36b0253.mp3";